<template>
  <div class="svg-wrapper">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve">
    <g>
      <line class="st0" x1="21.5" y1="235" x2="235.5" y2="21"/>
      <line class="st0" x1="21.5" y1="21" x2="235.5" y2="235"/>
    </g>
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'closeSvg',
  }
</script>

<style scoped>
  .svg-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  line {
    stroke: currentColor;
    stroke-width: 20px;
  }
</style>
